var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesst2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 11.6667C5.83325 10.8931 6.14054 10.1513 6.68752 9.60427C7.2345 9.05729 7.97637 8.75 8.74992 8.75H37.9166C38.6901 8.75 39.432 9.05729 39.979 9.60427C40.526 10.1513 40.8333 10.8931 40.8333 11.6667V61.25H8.74992C7.97637 61.25 7.2345 60.9427 6.68752 60.3957C6.14054 59.8488 5.83325 59.1069 5.83325 58.3333V11.6667Z",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6248 61.25V48.125C30.6248 46.9647 30.1639 45.8519 29.3434 45.0314C28.523 44.2109 27.4102 43.75 26.2498 43.75H20.4165C19.2562 43.75 18.1434 44.2109 17.3229 45.0314C16.5024 45.8519 16.0415 46.9647 16.0415 48.125V61.25M40.8332 35H61.2498C62.0234 35 62.7653 35.3073 63.3122 35.8543C63.8592 36.4013 64.1665 37.1431 64.1665 37.9167V58.3333C64.1665 59.1069 63.8592 59.8487 63.3122 60.3957C62.7653 60.9427 62.0234 61.25 61.2498 61.25H40.8332V35Z",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 26.25H29.1666M49.5833 43.75H55.4166M49.5833 52.5H55.4166M23.3333 20.4167V32.0833M10.2083 61.25H36.4583",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesst2);
export default __webpack_public_path__ + "static/media/tesst2.e75c61b8a01c314811aabc2173e03d72.svg";
export { ForwardRef as ReactComponent };